import "/dev-server/src/app.css?transform-only";export default "__VITE_CSS_URL__2f6465762d7365727665722f7372632f6170702e6373733f7472616e73666f726d2d6f6e6c79__"